import { UPDATE_USER } from './constants'

export const updateUser = (user) => {
  return {
    type: UPDATE_USER,
    user
  }
}



// WEBPACK FOOTER //
// ./src/reducers/global/user/actions.js